import { useErrorNotificationApi } from '@equifinance/shared';
import {
  UploadTaskDocumentPayload,
  Tasks,
  PostWrittenEvidencePayload,
  PostTaskNotePayload,
  TaskTypes,
  UnderwriterDecisionPayload,
} from '../contexts/tasks';

const apiPath = `${process.env.REACT_APP_ORIGINATION_API_PATH}/`;

const apiUrl = (path: string) => `${apiPath}${path}`;

export type TasksApiType = {
  postTask: (id: string) => Promise<Tasks>,
  getTasks: (id: string) => Promise<Tasks>,
  getTaskTypes: (id: string) => Promise<TaskTypes>,
  putTasks: (id: string, tasks: Tasks) => Promise<Tasks>,
  postTaskNote: (id: string, note: PostTaskNotePayload) => Promise<Tasks>,
  uploadDocuments: (applicationId: string, documents: UploadTaskDocumentPayload) => Promise<Tasks>,
  postWrittenEvidence: (applicationId: string, writtenEvidence: PostWrittenEvidencePayload) => Promise<Tasks>,
  postReadTask: (applicationId: string, taskId: string) => Promise<void>,
  postCancelTask: (applicationId: string, taskId: string) => Promise<Tasks>,
  postReturnToBroker: (applicationId: string, taskId: string) => Promise<Tasks>,
  postSubmitToLender: (applicationId: string, taskId: string) => Promise<Tasks>,
  postUnderwriterSubmission: (applicationId: string, underwriterDecision: UnderwriterDecisionPayload) => Promise<Tasks>,
}

export default function useTasksApi(): TasksApiType {
  const {
    put, get, post,
  } = useErrorNotificationApi(apiUrl);

  return {
    postTask: (id: string): Promise<Tasks> => post(`tasks/${id}`, {}),
    getTasks: (id: string): Promise<Tasks> => get(`tasks/${id}`),
    getTaskTypes: (id: string): Promise<TaskTypes> => get(`tasks/${id}/tasktypes`),
    putTasks: (id: string, tasks: Tasks): Promise<Tasks> => put(`tasks/${id}`, tasks),
    postTaskNote: (id: string, note: PostTaskNotePayload): Promise<Tasks> => post(`tasks/${id}/note`, note),
    uploadDocuments: (applicationId: string, documents: UploadTaskDocumentPayload) => post(`tasks/${applicationId}/document`, documents),
    postWrittenEvidence: (applicationId: string, writtenEvidence: PostWrittenEvidencePayload) => post(`tasks/${applicationId}/written-evidence`, writtenEvidence),
    postReadTask: (applicationId: string, taskId: string) => post(`tasks/${applicationId}/${taskId}/read`, {}),
    postCancelTask: (applicationId: string, taskId: string) => post(`tasks/${applicationId}/cancel`, { taskId }),
    postReturnToBroker: (applicationId: string, taskId: string) => post(`tasks/${applicationId}/return-to-broker`, { taskId }),
    postSubmitToLender: (applicationId: string, taskId: string) => post(`tasks/${applicationId}/submit-to-lender`, { taskId }),
    postUnderwriterSubmission: (applicationId: string, underwriterDecision: UnderwriterDecisionPayload) => post(`tasks/${applicationId}/underwriter-submission`, underwriterDecision),
  };
}
